<template>
  <div class="col-sm-12 col-lg-10 mx-auto my-2">
    <h5 class="text-secondary font-weight-bold">{{title}}</h5>
    <div class="col-8 text-left mx-auto text-secondary" v-if="user.abbonamento">
      <p class="text-capitalize">{{user.abbonamento.slug}}</p>
      <p
        v-if="user.abbonamento.durata > 0"
        class
      >Sottoscrizione valida per {{user.abbonamento.durata }}{{ user.abbonamento.durata == 1 ? ' mese' : ' mesi'}} dalla data di acquisto</p>

      <p class>
        Sottoscritto il
        <strong
          class="font-weight-light"
        >{{abbonamento.sottoscrizione.data_inizio | moment("DD MM YYYY")}}</strong> con scadenza in data
        <strong
          class="font-weight-light"
        >{{abbonamento.sottoscrizione.data_fine | moment("DD MM YYYY")}}</strong>
      </p>
      <p
        v-if="user.abbonamento.servizi.length > 0"
        class
      >Il tuo abbonamento prevede: {{user.abbonamento.servizi[user.abbonamento.servizi.length-1].nome }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "abbonamento",
  props: ["utente"],
  data() {
    return {
      user: this.utente,
      abbonamento: null
    };
  },
  computed: {
    title: function() {
      if (this.abbonamento) {
        return this.abbonamento.is_active
          ? "La tua sottoscrizione"
          : "Nessun abbonamento attivo";
      }
      return "";
    }
  },
  methods: {
    fetchData() {
      var url = process.env.VUE_APP_VERSION + "users/abbonamento/status";
      this.$axios
        .get(url)
        .then(res => {
          console.log(res.data.data);
          this.abbonamento = res.data.data;
        })
        .catch(err => {
          // console.log("error", err);
          // this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>